import { render, staticRenderFns } from "./OutputRecruitment.vue?vue&type=template&id=1338e8b9"
import script from "./OutputRecruitment.vue?vue&type=script&lang=js"
export * from "./OutputRecruitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports